var map = {
	"./about_1.jpg": "be25",
	"./about_2.jpg": "6da0",
	"./buyers_1.jpg": "207c",
	"./buyers_2.jpg": "b1ff",
	"./buyers_3.jpg": "7fa0",
	"./buyers_4.jpg": "a402",
	"./feedback-bg.jpg": "7f82",
	"./logo-white.jpg": "2e9b",
	"./main-title-bg.jpg": "8b0c",
	"./page-title-bg.jpg": "bd8d",
	"./product_1.jpg": "151b",
	"./production_1.jpg": "f6d3",
	"./production_2.jpg": "6c56",
	"./production_3.jpg": "b295",
	"./production_4.jpg": "ede0",
	"./services_1.jpg": "9ee1",
	"./services_2.jpg": "f4d6",
	"./services_3.jpg": "d3ad",
	"./ymap_fake.jpg": "0bcd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";